<template>
  <div id="app">
    <div class="parent">
      <div class="child" ref="main" @scroll="changePadding">
        <div class="head_wrapper">
          <defaultHeader v-if="$route.path != '/privacy'"></defaultHeader>
        </div>
        <div class="main_wrapper">
          <transition name="slide-fade">
            <router-view v-if="isRouterAlive" />
          </transition>
        </div>
        <div class="foot_wrapper">
          <defaultFooter v-if="$route.path != '/privacy'"></defaultFooter>
        </div>
        <login ref="login"></login>
        <register ref="register"></register>
        <resetPass ref="resetPass"></resetPass>
      </div>
    </div>
  </div>
</template>

<script>
import defaultHeader from '@/components/layout/header.vue';
import defaultFooter from '@/components/layout/footer.vue';
import register from '@/components/common/dialog/register/index';
import login from '@/components/common/dialog/login/index';
import resetPass from '@/components/common/dialog/forgetPassword/index';
import { mapActions, mapState } from 'vuex';
import event from '@/utils/event';
export default {
  data() {
    return {
      isRouterAlive: true,
      path: '',
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  computed: {
    ...mapState(['token']),
  },
  methods: {
    ...mapActions(['getDocsList', 'getDevelopInfo', 'getDashboardStatistics']),
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    checkBroswer() {
      const userAgent = window.navigator.userAgent;
      const isApple = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // 非chrome浏览器给出提示
      if (userAgent.indexOf('Chrome') < 0 && !isApple) {
        this.$notify({
          title: '温馨提示',
          message: '为了保证您在使用时有更优质的体验,请使用谷歌浏览器',
          type: 'warning',
          duration: 0,
        });
      }
    },
    changePadding() {
      let main = this.$refs.main;
      main.style.paddingRight = '0px';
    },
  },
  components: {
    defaultHeader,
    defaultFooter,
    register,
    login,
    resetPass,
  },
  created() {
    this.checkBroswer();
    this.getDocsList();
    // 已经登录的情况,每次刷新都要获取未读信息以及用户名还有头像
    if (this.token) {
      this.getDevelopInfo();
      this.getDashboardStatistics();
    }
  },
  mounted() {
    if (this.$route.path === '/login') {
      // 对控制台跳过来的登录页打开弹窗
      this.$nextTick(() => {
        this.$refs.login.open();
      });
    }
    // 打开登录弹框
    event.$on('openLogin', () => {
      this.$refs.login.open();
    });
    //打开注册弹框
    event.$on('openRegister', () => {
      this.$refs.register.open();
    });

    //打开忘记密码弹框
    event.$on('openResetPass', () => {
      this.$refs.resetPass.open();
    });
  },

  // updated() {
  //   console.log(this.$route);
  //   // 对控制台跳过来的登录页打开弹窗
  //   if (this.$route.path === '/login') {
  //     this.$nextTick(() => {
  //       this.$refs.login.open();
  //     });
  //   }
  // },
};
</script>

<style lang="scss">
@import './icons/iconfont/iconfont.css';
#app {
  .parent {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .child {
      width: 100vw;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-width: 1440px;
      margin: 0 auto;
      overflow-y: scroll;
      padding-right: 20px;
      .head_wrapper {
        position: relative;
      }
      .main_wrapper {
        position: relative;
        // background: #fff;
        min-height: 800px;
      }
      .foot_wrapper {
        background: #262e44;
        width: 100%;
      }
    }
  }
}

/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.1s ease-in-out;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-48px);
  opacity: 1;
}
</style>
